import { api } from 'shared';
import { z } from 'zod';

const CulinaryStudioArticlesByUidsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            portions: z.array(
                z.object({
                    id: z.number(),
                    price: z.number().optional().nullable(),
                    value: z.number(),
                    meassure: z.string(),
                    currency: z.object({
                        abbreviation: z.string(),
                    }).optional().nullable(),
                }),
            ).optional().nullable(),
            sets: z.array(
                z.object({
                    id: z.number(),
                    name: z.string(),
                }),
            ).optional().nullable(),
        }),
    ),
});

export const fetchCulinaryStudioArticlesByUids = async (uids: string[]) => (
    api.get<z.infer<typeof CulinaryStudioArticlesByUidsResponseSchema>>(
        '/culinary-studio-articles',
        {
            filters: {
                slug: {
                    $in: uids,
                },
            },
            populate: {
                images: {
                    fields: '*',
                },
                portions: {
                    populate: {
                        currency: {
                            fields: '*',
                        },
                    },
                },
                sets: {
                    fields: '*',
                },
            },
        },
        CulinaryStudioArticlesByUidsResponseSchema,
    )
);
